import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import { DetailSection, FieldGrid, FieldItem } from "components/detail";

export const AgentShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    현장요원 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    현장요원 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* 원본이 raw 값을 그대로 노출했으므로 매핑 없이 유지 */}
                        <FieldItem label="이름" value={record?.name} />
                        <FieldItem label="코드" value={record?.code} />
                        <FieldItem label="로그인ID" value={record?.loginId} />
                        <FieldItem label="전화번호" value={record?.phoneNumber} />
                        <FieldItem label="주소" span={2} value={record?.a_address} />
                        <FieldItem label="상태" value={record?.a_status} />
                        <FieldItem label="자차여부" value={record?.a_hasCar} />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="장비 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="장비번호" value={record?.a_equipment} />
                        <FieldItem label="장비발송일" value={record?.a_dispatchDate} />
                        <FieldItem label="장비수령일" value={record?.a_receiveDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
